import {
    Component,
    Input,
    Output,
    ElementRef,
    OnChanges,
    AfterViewInit,
    SimpleChanges,
    EventEmitter
} from '@angular/core';

import {ProductGroup} from "../model/product.group";
import {EventsService} from "../services/events.service";
import {Logger} from "../utils/logger";
import {SubProduct, SubProductSelectedEvent} from "../model/subproduct";
import {Product} from "../model/product";

@Component({
    selector: 'subproduct',
    templateUrl: "./subproduct.component.html"
})

export class SubProductComponent implements AfterViewInit, OnChanges {
    @Input()
    public subProduct;

    @Input()
    public product;

    @Input("group")
    public productGroup;

    @Input()
    public tabContent;

    @Input()
    public alternativeIndex = 0;

    @Output('onSubProductSelected')
    public subProductSelected: EventEmitter<SubProductSelectedEvent>;

    public isLoadingShow = false;

    constructor(public el: ElementRef, public eventBus: EventsService, public logger: Logger) {
        this.subProductSelected = new EventEmitter<SubProductSelectedEvent>();
    }

    ngAfterViewInit(): any {
        if (this.subProduct) {
            let img = this.el.nativeElement.querySelector('.subproduct-img');

            img.addEventListener('load', () => {
                $(img).animate({opacity: 1}, 500);
            });

            img.src = this.subProduct.thumbPath1.getValue();
        }
    }

    ngOnChanges(changes: any): any {
        // console.log('changes subProduct');
        if (typeof changes.subProduct !== 'undefined' && changes.subProduct.currentValue) {
            this.eventBus.on("subProducts.renderImageLoaded." + this.subProduct.id.getValue() + "-" + this.subProduct.articleNumber.getValue(), this.onSubProductImageLoaded, this);
        }
    }

    onSubProductImageLoaded(event: {subProduct: SubProduct, groupName: string}) {
        if (this.subProduct) {
            this.isLoadingShow = false;
        }
    }

    imageHeight() {
        let height = 145;

        return height + "px";
    }

    public showSubProductSpinner() {
        this.isLoadingShow = true;
    }

    onSelected(event: Event, subProduct: SubProduct, product: Product, group: ProductGroup) {
        if ((event.target as HTMLElement).className.toLowerCase() !== 'info') {
            this.showSubProductSpinner();
            this.subProductSelected.emit({subProduct: subProduct, product: product, productGroup: group});
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/sidebar/subproduct.component.ts